import { render, staticRenderFns } from "./RipaPwaWrapper.vue?vue&type=template&id=500c7d10"
import script from "./RipaPwaWrapper.vue?vue&type=script&lang=js"
export * from "./RipaPwaWrapper.vue?vue&type=script&lang=js"
import style0 from "./RipaPwaWrapper.vue?vue&type=style&index=0&id=500c7d10&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports